/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "240")


  
    
export interface API22540Item {
  
  /** 项目ID，应与用户中心project-id相同，做授权和数据脱敏用 */
  projectId?: string;
  
  /** 项目名称 */
  projectName?: string;
  
  /** 任务ID */
  taskId?: string;
  
  /** 导出记录ID */
  recordingId?: string;
  
  /** 文件名 */
  fileName?: string;
  
  /** 导出用户ID */
  doExportUserId?: string;
  
  /** 导出用户名 */
  doExportUserName?: string;
  
  /** 导出开始时间 */
  startTime?: any;
  
  /** 导出结束时间 */
  endTime?: any;
  
  /** 进度百分比 */
  processPercent?: string;
  
  /** 导出显示状态,@seeShowExportStatusEnum */
  showExportStatus?: string;
  
  /** 导出状态显示文案 */
  exportStatusStr?: string;
  
  /** 下载地址 */
  downloadUrl?: string;
  
  /** 菜单名称 */
  menuName?: string;
  
  /** 是否脱敏 */
  isSensitive?: boolean;
  
};
    
  



export interface API22540Req {
  
  /** 项目ID，应与用户中心project-id相同，做授权和数据脱敏用 */
  projectId?: string;
    
  /** 任务ID */
  taskId?: string;
    
  /** 文件名 */
  fileName?: string;
    
  /** 导出用户ID */
  doExportUserId?: string;
    
  /** 导出状态,@deprecated使用showExportStatus代替 */
  exportStatus?: string;
    
  /** 展示用的导出状态：EXPORTING-导出中，DONE-导出成功，STOPPED-导出停止 */
  showExportStatus?: string;
    
  /** 是否脱敏：true-脱敏，false-不脱敏 */
  isSensitive?: string;
    
  /** 创建时间范围--开始 */
  createdAtStart?: string;
    
  /** 创建时间范围--结束 */
  createdAtEnd?: string;
    
  /** 完成时间范围--开始 */
  finishedAtStart?: string;
    
  /** 完成时间范围--结束 */
  finishedAtEnd?: string;
    
  /** 一级菜单ID */
  menuId?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API22540Res {
  /** T  */
  list?: API22540Item[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 22540 导出列表查询

export interface IUseGetAPI22540Return {
  /** 导出列表查询: 接口请求状态 */
  isAPI22540Loading: boolean;
  /** 导出列表查询: 接口请求返回数据 */
  dataAPI22540: API22540Res;
  /**  导出列表查询: 接口数据请求方法 */
  fetchAPI22540Data:  (inputs: API22540Req, config?: YWRequestConfig) => Promise<API22540Res>;
  /** 导出列表查询: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI22540 = ():IUseGetAPI22540Return => {
  let isMount = true;
  const [isAPI22540Loading, setIsAPI22540Loading] = useState(false);
  const [dataAPI22540, setDataAPI22540] = useState<API22540Res>({} as API22540Res);
  const requestUrl = `${basePath}/ywwl-upload-export/export/task/exportList`;

  const fetchAPI22540Data = async (inputs: API22540Req, config?: YWRequestConfig): Promise<API22540Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API22540Req>) || {}) as API22540Req;
    
  
    if ( isMount ) {
      setIsAPI22540Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API22540Res>(`${basePath}/ywwl-upload-export/export/task/exportList?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI22540(res || {} as API22540Res);
        setIsAPI22540Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI22540Loading(false);
      }
      return false as unknown as API22540Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI22540Loading,
    dataAPI22540,
    fetchAPI22540Data,
    requestUrl,
  }
}

